import { BaseService, Service } from "/@/cool";

@Service("openapiAccount")
class OpenapiAccount extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["info"] = prefix + "info";
		this.permission["appsecret"] = prefix + "appsecret";
		this.permission["resetAppsecret"] = prefix + "resetAppsecret";
		this.permission["tokenGenerate"] = prefix + "tokenGenerate";
		this.permission["tokenPage"] = prefix + "tokenPage";
		this.permission["expireTokenRecord"] = prefix + "expireTokenRecord";
		this.permission["requestLogPage"] = prefix + "requestLogPage";
	}

	info(data: any) {
		return this.request({
			url: "/info",
			method: "POST",
			data
		});
	}

	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}

	appsecret(data: any) {
		return this.request({
			url: "/appsecret",
			method: "POST",
			data
		});
	}

	resetAppsecret(data: any) {
		return this.request({
			url: "/resetAppsecret",
			method: "POST",
			data
		});
	}

	tokenGenerate(data: any) {
		return this.request({
			url: "/tokenGenerate",
			method: "POST",
			data
		});
	}

	tokenPage(data: any) {
		return this.request({
			url: "/tokenPage",
			method: "POST",
			data
		});
	}

	expireTokenRecord(data: any) {
		return this.request({
			url: "/expireTokenRecord",
			method: "POST",
			data
		});
	}

	requestLogPage(data: any) {
		return this.request({
			url: "/requestLogPage",
			method: "POST",
			data
		});
	}
}

export default OpenapiAccount;
